import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../StateContext/Application'
import { apiurl } from '../../../../path'
import { useLanguage } from '../../../../lang/langcontext/LanguageContext'
const WorkOrderList = () => {
    const { language, toggleLanguage, t } = useLanguage();
    const context = useContext(AdminContext)
    const { GetAllWorkOrderList } = context
    const [workorder, setWorkOrderList] = useState([])
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

    const getWorkOrderList = async () => {
        let data = await GetAllWorkOrderList()
        console.log("data", data);

        setWorkOrderList(data)
        setFilteredBills(data);
    }
    useEffect(() => {
        getWorkOrderList()
    }, [])
    let workorderList = []
    if (workorder.length > 0) {
        workorderList = workorder
    }
    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = workorder.filter(bill =>
            Object.values(bill).some((val) =>
                (val || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1); // Reset to page 1 on search
    }, [searchTerm, workorder]);
    // return (
    //     <div style={{ overflowX: "hidden", display: 'grid', justifyContent: 'center', padding: "20px 0px" }}>
    //         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "80vw", maxWidth: "1200px", marginBottom: "15px" }}>
    //             <h4 style={{ margin: "10px" }}>Work Order List</h4>
    //             <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} />
    //         </div>
    //         <div style={{ display: "grid", justifyContent: "center", width: "80vw", maxWidth: "100%", }}>
    //             <div style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', display: 'flex', width: '75vw', overflowX: "auto", border: '1px solid #3b409e' }}>
    //                 <table style={{ width: '100%', width: "100%", borderCollapse: "collapse", minWidth: "1200px", }}>
    //                     <thead style={{ borderTop: 'none' }}>
    //                         <tr style={{ color: 'white', border: 'none', overflow: 'hidden', height: '3.5rem' }}>
    //                             <th style={{ padding: '8px' }}>Financial Year</th>
    //                             <th style={{ padding: '8px' }}>Project ID</th>
    //                             <th style={{ padding: '8px' }}>Project Name</th>
    //                             <th style={{ padding: '8px' }}>Project Cost</th>
    //                             <th style={{ padding: '8px' }}>GRCopy</th>
    //                             <th style={{ padding: '8px' }}>Budget Head</th>
    //                             <th style={{ padding: '8px' }}>Vendor Name</th>
    //                             <th style={{ padding: '8px' }}>Work Name</th>
    //                             <th style={{ padding: '8px' }}>Work Order No</th>
    //                             <th style={{ padding: '8px' }}>Work Order Date</th>
    //                             <th style={{ padding: '8px' }}>Work End Date</th>
    //                             <th style={{ padding: '8px' }}>Approved Work Amount</th>
    //                             <th style={{ padding: '8px' }}>Paid Amount</th>
    //                             <th style={{ padding: '8px' }}>Remaining Amount</th>
    //                             <th style={{ padding: '8px' }}>Copy of Work Order</th>
    //                             <th style={{ padding: '8px' }}>Creation Date</th>
    //                         </tr>
    //                     </thead>
    //                     {
    //                         currentBills?.map((workorder, index) => {
    //                             const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
    //                             return (
    //                                 <tbody>
    //                                     <tr style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor, }}>
    //                                         <td style={{ padding: '8px' }}>{workorder.FinancialYear}</td>
    //                                         <td style={{ padding: '8px' }}>{workorder.ProjectID}</td>
    //                                         <td style={{ padding: '8px' }}>{workorder.ProjectName}</td>
    //                                         <td style={{ padding: '8px' }}>{workorder.ProjectCost}</td>
    //                                         <td style={{ padding: '8px' }}><a href={`${apiurl}/ProjectDocsImages/${workorder.GRCopy}`} target='_blank'>{workorder.GRCopy}</a></td>
    //                                         <td style={{ padding: '8px' }}>{workorder.BudgetHead}</td>
    //                                         <td style={{ padding: '8px' }}>{workorder.ContractorName}</td>
    //                                         <td style={{ padding: '8px' }}>{workorder.WorkName}</td>
    //                                         <td style={{ padding: '8px' }}>{workorder.WorkOrderNo}</td>
    //                                         <td style={{ padding: '8px' }}>{workorder.WorkOrderDate?.split('T')[0].replace(' ')}</td>
    //                                         <td style={{ padding: '8px' }}>{workorder.WorkEndDate?.split('T')[0].replace(' ')}</td>
    //                                         <td style={{ padding: '8px' }}>{workorder.ApprovedWorkAmount
    //                                         }</td>
    //                                         <td style={{ padding: '8px' }}>{workorder.PaidAmount}</td>
    //                                         <td style={{ padding: '8px' }}>{workorder.RemainingAmount}</td>
    //                                         <td style={{ padding: '8px' }}><a href={`${apiurl}/WorkOrderDocsImages/${workorder.CopyofWorkOrder}`} target='_blank'>{workorder.CopyofWorkOrder}</a></td>
    //                                         <td style={{ padding: '8px' }}>{workorder.PaidAmount}</td>
    //                                         <td style={{ padding: '8px' }}>{workorder.Date?.split('T')[0].replace(' ')}</td>
    //                                     </tr>
    //                                 </tbody>
    //                             )
    //                         })
    //                     }
    //                 </table>
    //             </div>
    //         </div>
    //         <div style={{ display: 'flex', justifyContent: 'space-between', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
    //             <div>
    //                 <p style={{ margin: '0px', color: 'black' }}>Showing {filteredBills?.length} of {workorder?.length} entries</p>
    //             </div>
    //             <div style={{ display: 'flex', alignItems: 'center' }}>
    //                 {/* First Page Button */}
    //                 <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
    //                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
    //                     &laquo;
    //                 </button>
    //                 {/* Previous Button */}
    //                 <button
    //                     onClick={() => setCurrentPage(currentPage - 1)}
    //                     disabled={currentPage === 1}
    //                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
    //                     &lt;
    //                 </button>

    //                 <button
    //                     style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
    //                 </button>
    //                 {/* Next Button */}
    //                 <button
    //                     onClick={() => setCurrentPage(currentPage + 1)}
    //                     disabled={currentPage === totalPages}
    //                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
    //                     &gt;
    //                 </button>
    //                 {/* Last Page Button */}
    //                 <button
    //                     onClick={() => setCurrentPage(totalPages)}
    //                     disabled={currentPage === totalPages}
    //                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
    //                     &raquo;
    //                 </button>
    //             </div>

    //         </div>
    //     </div>
    // )
     return (
        <div style={{ overflowX: "hidden", display: 'grid', justifyContent: 'center', padding: "20px 0px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "80vw", maxWidth: "1200px", marginBottom: "15px" }}>
                <h4 style={{ margin: "10px" }}>{t("Work Order List")}</h4>
                <input type="text" placeholder={t("Search")} onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} />
            </div>
            <div style={{ display: "grid", justifyContent: "center", width: "80vw", maxWidth: "100%", }}>
                <div style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', display: 'flex', width: '75vw', overflowX: "auto", border: '1px solid #3b409e' }}>
                    <table style={{ width: '100%', width: "100%", borderCollapse: "collapse", minWidth: "1200px", }}>
                        <thead style={{ borderTop: 'none' }}>
                            <tr style={{ color: 'white', border: 'none', overflow: 'hidden', height: '3.5rem' }}>
                                <th style={{ padding: '8px' }}>{t("Financial Year")}</th>
                                <th style={{ padding: '8px' }}>{t("Project ID")}</th>
                                <th style={{ padding: '8px' }}>{t("Project Name")}</th>
                                <th style={{ padding: '8px' }}>{t("Project Cost")}</th>
                                <th style={{ padding: '8px' }}>{t("GRCopy")}</th>
                                <th style={{ padding: '8px' }}>{t("Budget Head")}</th>
                                <th style={{ padding: '8px' }}>{t("Vendor Name")}</th>
                                <th style={{ padding: '8px' }}>{t("Work Name")}</th>
                                <th style={{ padding: '8px' }}>{t("Work Order No")}</th>
                                <th style={{ padding: '8px' }}>{t("Work Order Date")}</th>
                                <th style={{ padding: '8px' }}>{t("Work End Date")}</th>
                                <th style={{ padding: '8px' }}>{t("Approved Work Amount")}</th>
                                <th style={{ padding: '8px' }}>{t("Paid Amount")}</th>
                                <th style={{ padding: '8px' }}>{t("Remaining Amount")}</th>
                                <th style={{ padding: '8px' }}>{t("Copy of Work Order")}</th>
                                <th style={{ padding: '8px' }}>{t("Creation Date")}</th>
                            </tr>
                        </thead>
                        {
                            currentBills?.map((workorder, index) => {
                                const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                    <tbody>
                                        <tr style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor, }}>
                                            <td style={{ padding: '8px' }}>{workorder.FinancialYear}</td>
                                            <td style={{ padding: '8px' }}>{workorder.ProjectID}</td>
                                            <td style={{ padding: '8px' }}>{workorder.ProjectName}</td>
                                            <td style={{ padding: '8px' }}>{workorder.ProjectCost}</td>
                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ProjectDocsImages/${workorder.GRCopy}`} target='_blank'>{workorder.GRCopy}</a></td>
                                            <td style={{ padding: '8px' }}>{workorder.BudgetHead}</td>
                                            <td style={{ padding: '8px' }}>{workorder.ContractorName}</td>
                                            <td style={{ padding: '8px' }}>{workorder.WorkName}</td>
                                            <td style={{ padding: '8px' }}>{workorder.WorkOrderNo}</td>
                                            <td style={{ padding: '8px' }}>{workorder.WorkOrderDate?.split('T')[0].replace(' ')}</td>
                                            <td style={{ padding: '8px' }}>{workorder.WorkEndDate?.split('T')[0].replace(' ')}</td>
                                            <td style={{ padding: '8px' }}>{workorder.ApprovedWorkAmount
                                            }</td>
                                            <td style={{ padding: '8px' }}>{workorder.PaidAmount}</td>
                                            <td style={{ padding: '8px' }}>{workorder.RemainingAmount}</td>
                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/WorkOrderDocsImages/${workorder.CopyofWorkOrder}`} target='_blank'>{workorder.CopyofWorkOrder}</a></td>
                                            <td style={{ padding: '8px' }}>{workorder.PaidAmount}</td>
                                            <td style={{ padding: '8px' }}>{workorder.Date?.split('T')[0].replace(' ')}</td>
                                        </tr>
                                    </tbody>
                                )
                            })
                        }
                    </table>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
                <div>
                    <p style={{ margin: '0px', color: 'black' }}>{t("Showing")} {filteredBills?.length} {t("of")} {workorder?.length} {t("entries")}</p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* First Page Button */}
                    <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
                        &laquo;
                    </button>
                    {/* Previous Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &lt;
                    </button>

                    <button
                        style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                    </button>
                    {/* Next Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &gt;
                    </button>
                    {/* Last Page Button */}
                    <button
                        onClick={() => setCurrentPage(totalPages)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &raquo;
                    </button>
                </div>

            </div>
        </div>
    )
}

export default WorkOrderList
